import React, { Fragment, useEffect, useState } from "react";
import { useSelector } from "react-redux";
import ErrorMessage from "../Common/Components/ErrorMessage";
import Spinner from "../Common/Components/spinner";
import { machineHealthDataToHours, msToHours } from "../Common/Util_methods/format";
import MachineHealthChart from "./MachineHealthChart"
import { getInterruptsSelector, loadingInterruptsSelector } from "./machineHealthSlice";

interface MachineHealthChartWidgetProps{
    id:string;
    header:string;
    legendSeries:any[];
    updateLegendSeries:any;
}

interface ChartData{
    all: number;
    date: string | Date
    interruptCount: number
    interruptsPerRunningHour: number;
    runningDuration: number;
    seriesID: string;
}
const MachineHealthChartWidget = (props:MachineHealthChartWidgetProps) =>{
    const [chartData, updateChartData] = useState([]);
    const [totalData, updateTotalData] = useState([])
    const [dataProcessed, setDataProcessed] = useState(false);
    const interruptData = useSelector(getInterruptsSelector).interruptData;
    const loadingState = useSelector(loadingInterruptsSelector);

    useEffect(()=>{
        if(interruptData.length > 0 && loadingState !== "pending"){
            updateChartData(formatInterruptData())
            updateTotalData(machineHealthDataToHours(interruptData))
        }else{
            updateChartData([])
            updateTotalData([])
        }
        setDataProcessed(true);
    },[interruptData])

    useEffect(()=>{
        
        if(loadingState === "pending"){
            setDataProcessed(false);
        }
        if(loadingState === "rejected"){
            setDataProcessed(true);
        }
        if(loadingState === "fulfilled" && interruptData.length === 0){
            setDataProcessed(true);
        }
    },[loadingState])

    const formatInterruptData = () =>{
        let combined = [] as ChartData[];
        interruptData.forEach(obj => {
            combined = combined.concat(obj.dailyData)
        });
        const combinedForChart = combined.map((obj)=>{
            obj = {...obj,[obj.seriesID]: obj.interruptsPerRunningHour,["date"+obj.seriesID]:new Date(obj.date)}
            obj.date = new Date(obj.date)
            obj.runningDuration = msToHours(obj.runningDuration)
            return obj
        })
        return combinedForChart;
    }

    if (!dataProcessed){
        return <Spinner text="data" />;
    }
    if (interruptData == null || loadingState === "rejected") {
        //proper error handling should be added with promise error response
        return (
            <ErrorMessage
                text={"Oops something went wrong, unable to get data."}
                id={props.id}
                header={props.header}
            />
        );
    }   
    if (chartData != null && chartData.length == 0) {
        return (
            <Fragment>
                <ErrorMessage
                text={"No data found for selected filters."}
                id={props.id}
                header={props.header}
                />
                <div style={{"visibility":"hidden"}}>
                    <MachineHealthChart id="interrupt-chart" chartData={chartData} totalData={totalData} updateLegendSeries={props.updateLegendSeries}/>
                </div>
            </Fragment>
        );
    }

    return <MachineHealthChart id="interrupt-chart" chartData={chartData} totalData={totalData} updateLegendSeries={props.updateLegendSeries}/>
}

export default MachineHealthChartWidget;